import { useRefreshToken } from 'features/auth/hooks/useAuthData';
import { logoutThunk } from 'features/auth/thunks/logoutThunk';
import { useLogoutMutation } from 'services/authService';
import { useAppDispatch } from 'store/store';

export const useLogout = () => {
  const dispatch = useAppDispatch();
  const [logout] = useLogoutMutation();
  const refreshToken = useRefreshToken();

  const handleLogout = async () => {
    try {
      // Dispatch logoutThunk and wait for it to finish
      if (!refreshToken) return;
      logout({ refreshToken });
      await dispatch(logoutThunk()).unwrap();
    } catch (error) {
      // Handle logout failure gracefully
      console.log('Logout failed');
    }
  };

  return { handleLogout };
};
